export default "__VITE_ASSET__cb34a91e__"